import {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { useUserContext } from '../hooks/useUserContext';
import { useAuthHeader } from '../hooks/useAuthHeader';
import { paths } from '../utils/paths';
import './App.css';
import { BVTConstants } from '../utils/BVTConstants';

function App() {

  const user = useUserContext();
  const navigate = useNavigate();
  const authHeader = useAuthHeader();
  const {dispatch} = useAuthContext();

  useEffect(() => {
    console.log('user: ' + user);
    if(user === null){
        console.log('No user found, routing to login page.') 
        authHeader.removeAuthHeader(); 
        navigate(paths.auth.signIn, {replace: true});
    }else if(user.role === BVTConstants.USER_TYPE_ADMIN){
        console.log('Loading admin dashboard');
        navigate(paths.admin.home, {replace: true});
    }else if(user.role === BVTConstants.USER_TYPE_BUSINESS){
        console.log('Loading Business dashboard');
        navigate(paths.business.home, {replace: true});
    }else if(user.role === BVTConstants.USER_TYPE_AGENT || user.role === BVTConstants.USER_TYPE_COMPANY){
        console.log('Loading Agent Page');
        navigate(paths.agent.home, {replace: true});
    }else {
        console.log('No role found, logging out.')
        authHeader.removeAuthHeader(); 
        dispatch({type: 'LOGOUT', payload: null})
        navigate(paths.auth.signup, {replace: true});
    }
  }, [navigate, user])

  return null;
}

export default App;
